import React from 'react';
import { SadIconLazy, HahaIconLazy, AngryIconLazy, ThumbsUpIconLazy, ClapIconLazy, WowIconLazy, CuriousIconLazy, HeartIconLazy, SmileyIconLazy, } from './icons';
import classNames from 'classnames';
import styles from './reaction-icon.scss';
import cssVars from '../styles/css-vars.scss';
const reactionNameToIconMap = {
    angry: AngryIconLazy,
    clap: ClapIconLazy,
    surprised: WowIconLazy,
    thinking: CuriousIconLazy,
    lol: HahaIconLazy,
    heart: HeartIconLazy,
    thumbsup: ThumbsUpIconLazy,
    sad: SadIconLazy,
    smiley: SmileyIconLazy,
};
export const ReactionIcon = ({ reactionName, className, dataHook, }) => {
    const Icon = reactionNameToIconMap[reactionName];
    return (React.createElement("div", { className: classNames(styles.container, cssVars.reactionsContainer, className), "data-hook": dataHook }, Icon ? React.createElement(Icon, { style: { width: '100%', height: '100%' } }) : null));
};
//# sourceMappingURL=reaction-icon.js.map